// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1P47i","footer":"ModalCreateQualiphyProcedure_footer__2z_T7","additionData":"ModalCreateQualiphyProcedure_additionData__2t72I"};